import { switchMap, map } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { userSaveFavorite } from 'constants/routes';
import { camelCaseObjectKeys } from 'utils/camelCase';

function saveUserFavorite(payload) {
  const url = `${userSaveFavorite}`;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json()),
    map((response) => camelCaseObjectKeys(response))
  );
}

export default saveUserFavorite;
